/**
 * Created by linjianxi on 2017/1/18.
 */
export const GET_RED_LIST = 'GET_RED_LIST'



// WEBPACK FOOTER //
// ./src/vuex/modules/packet/mutation-type.js